import { SelectedFeatureData } from 'features/siteMap/contexts/FeatureInteractionContext'
import { ConfirmButton } from 'features/siteMap/popupMenus/editMode/editFeature/ConfirmButton'
import { CoordinateInputSection } from 'features/siteMap/popupMenus/editMode/editFeature/CoordinateInputSection'
import { DeleteFeatureButton } from 'features/siteMap/popupMenus/editMode/editFeature/DeleteFeatureButton'
import { ScaleInputSection } from 'features/siteMap/popupMenus/editMode/editFeature/scale/ScaleInputSection'
import { SelectCoordinatesOnMapButton } from 'features/siteMap/popupMenus/editMode/editFeature/SelectCoordinatesOnMapButton'
import { ShapeSelector } from 'features/siteMap/popupMenus/editMode/editFeature/ShapeSelector'
import React, { FC } from 'react'
import styled from 'styled-components'
import { GeckoUnit, SiteFeaturePrimitive } from 'types'

import { RotationInput } from './RotationInput'
import { UnitIDInput } from './UnitIDInput'

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

interface EditFeatureMenuContentProps {
  selectedFeature: SelectedFeatureData | undefined
  selectedFeaturePrimitive: SiteFeaturePrimitive | undefined
  allUnitsAtSite: ReadonlyArray<GeckoUnit>
}

export const EditFeatureMenuContent: FC<EditFeatureMenuContentProps> = (
  props
) => {
  return (
    <ContentContainer>
      {!props.selectedFeature ? (
        <SelectCoordinatesOnMapButton
          feature={props.selectedFeature}
          minimized={false}
        />
      ) : props.selectedFeaturePrimitive ? (
        <>
          <UnitIDInput
            feature={props.selectedFeaturePrimitive}
            allUnitsAtSite={props.allUnitsAtSite}
          />
          <CoordinateInputSection
            feature={props.selectedFeaturePrimitive}
            featureType={props.selectedFeature.type}
          />
          <ShapeSelector
            feature={props.selectedFeaturePrimitive}
            featureType={props.selectedFeature.type}
          />
          <ScaleInputSection
            feature={props.selectedFeaturePrimitive}
            featureType={props.selectedFeature.type}
          />
          <RotationInput
            feature={props.selectedFeaturePrimitive}
            featureType={props.selectedFeature.type}
          />
          <ConfirmButton />
          <DeleteFeatureButton feature={props.selectedFeaturePrimitive} />
        </>
      ) : null}
    </ContentContainer>
  )
}
